module.exports = __webpack_public_path__ + "static/media/ip1.42fc0622.jpg";